/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { useLocale, useTranslation, dateRangeToYears } from '../utils'

function SEO({ description, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )

  const { locale } = useLocale();
  const t = useTranslation();

  const metaDescription = description || site.siteMetadata.description
  const metaTitle =  title || site.siteMetadata.title
  const titleTemplate = title ? `%s | ${t(site.siteMetadata.title)}` : null

  const translatedDescription = t(metaDescription, {
    years: dateRangeToYears(new Date('2015-05-15'), new Date())
  })

  return (
    <Helmet
      htmlAttributes={{
        lang: locale
      }}
      title={t(metaTitle)}
      titleTemplate={titleTemplate}
      meta={[
        {
          name: `description`,
          content: translatedDescription,
        },
        {
          property: `og:title`,
          content: t(metaTitle),
        },
        {
          property: `og:description`,
          content: translatedDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: 'https://simon-martineau.com/card.png',
        },
        {
          property: `og:image:alt`,
          content: 'Simon Martineau',
        },
        {
          property: `og:locale`,
          content: locale,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        // {
        //   name: `twitter:creator`,
        //   content: t(site.siteMetadata.author),
        // },
        {
          name: `twitter:title`,
          content: t(metaTitle),
        },
        {
          name: `twitter:description`,
          content: translatedDescription,
        },
        {
          name: `twitter:image`,
          content: 'https://simon-martineau.com/card.png',
        },
        {
          name: `twitter:image:alt`,
          content: 'Simon Martineau',
        }
      ].concat(meta)}
      link={[
        {
          rel: 'icon',
          sizes: '192x192',
          href: '../../icon.png'
        },
        {
          rel: 'apple-touch-icon',
          href: '../../icon.png'
        },
        {
          rel: 'mask-icon',
          href: '../../icon.svg',
          color: '#ff6a4d'
        }
      ]}
    />
  )
}

SEO.defaultProps = {
  meta: [],
  description: ``,
  title: '',
}

SEO.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default SEO
